module.exports = __webpack_public_path__ + "static/media/panel-beater.9bf7506a.jpg";